/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Einwilligungserklaerungmasernimpfungnachweiserhalten3Inputs */

const de__field_einwilligungserklaerungmasernimpfungnachweiserhalten3 = /** @type {(inputs: _Field_Einwilligungserklaerungmasernimpfungnachweiserhalten3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einwilligungserklärung Masernimpfung Nachweis erhalten`)
};

/**

* @param {_Field_Einwilligungserklaerungmasernimpfungnachweiserhalten3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_einwilligungserklaerungmasernimpfungnachweiserhalten3 = /** @type {((inputs?: _Field_Einwilligungserklaerungmasernimpfungnachweiserhalten3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Einwilligungserklaerungmasernimpfungnachweiserhalten3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_einwilligungserklaerungmasernimpfungnachweiserhalten3(inputs)
});
export { _field_einwilligungserklaerungmasernimpfungnachweiserhalten3 as "_field_einwilligungserklaerungMasernimpfungNachweisErhalten" }